module.exports = __webpack_public_path__ + "img/delete.de8a164d.svg";